import { render, staticRenderFns } from "./Micro.vue?vue&type=template&id=625ca426&scoped=true"
import script from "./Micro.vue?vue&type=script&lang=js"
export * from "./Micro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625ca426",
  null
  
)

export default component.exports